import type { FaireProductEntity } from "../../entity_types/product";

export const p_egr4eqjwve: FaireProductEntity = {
  token: "p_egr4eqjwve",
  type: "product",
  name: "Thank You a Bunch",
  brandToken: "b_cf1d364a",
  brandName: "Hartland Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/1736f168dad64dcf4e5c70f6c07cbb7ffd469ea47719b2163541f832cba12d0f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07bf0d9386abde901a198ea96116064787ecb4b386e5248a8da3d39dda48f6d7.jpeg",
    "https://cdn.faire.com/fastly/6babce9042888b3e74a17223b7b5afc860e3f8e611046d5204673f5993c2d4f2.jpeg",
  ],
  priceDollars: 2.75,
  description:
    '- 4.25" x 5.5" blank card \n- Comes with a kraft envelope in a protective eco-sleeve\n- 100% post-consumer fiber envelope\n- Offset printed on 100% recycled felt paper in New York',
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:15.784Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
